import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const worli: AreaConfig = {
  name: 'Worli & Lower Parel',
  slug: 'worli',
  tagline: 'Premium Doorstep Mobile Repair in Worli & Lower Parel',
  description: 'From Worli Sea Face to the corporate towers of Lower Parel, minto provides doorstep iPhone and premium phone repair. Skip the service center queue — our certified technicians visit your high-rise apartment or office. OEM parts, 6-month warranty, 30-minute arrival.',
  localities: [
    'Worli', 'Worli Sea Face', 'Worli Naka', 'Lower Parel',
    'Prabhadevi', 'Century Mills', 'One World Centre', 'Kamala Mills',
    'Phoenix Mills', 'Senapati Bapat Marg', 'Elphinstone Road',
    'Mahalaxmi', 'Haji Ali', 'Currey Road',
  ],
  zones: [
    {
      name: 'Worli & Sea Face',
      line: 'Western Line',
      station: 'Lower Parel / Mahalaxmi Station',
      localities: ['Worli Sea Face', 'Worli Village', 'Worli Naka', 'Worli BDD Chawl', 'Haji Ali', 'Mahalaxmi'],
      desc: 'Premium sea-facing residential towers and legacy apartments. Technician available within 30 minutes for any iPhone or smartphone repair.',
    },
    {
      name: 'Lower Parel & Prabhadevi Corporate Hub',
      line: 'Western Line',
      station: 'Lower Parel Station / Elphinstone Road',
      localities: ['Lower Parel', 'Prabhadevi', 'Kamala Mills', 'Phoenix Mills', 'One World Centre', 'Century Mills', 'Senapati Bapat Marg', 'Peninsula Corporate Park'],
      desc: 'Mumbai\'s biggest corporate district. We repair phones at your office desk — perfect for busy professionals who can\'t spare time for a service center visit.',
    },
  ],
  seo: {
    title: 'Mobile Repair in Worli & Lower Parel | Doorstep iPhone Repair | minto',
    description: 'Premium doorstep mobile repair in Worli, Lower Parel, Prabhadevi. iPhone battery replacement, screen repair with OEM parts. 6-month warranty. Apple Store alternative. 30-min service at your home or office.',
    keywords: 'mobile repair Worli, iPhone repair Lower Parel, phone repair Prabhadevi, battery replacement Worli, screen repair Lower Parel, doorstep mobile repair Worli Sea Face, iPhone service Kamala Mills, phone repair Phoenix Mills, mobile repair Mahalaxmi, premium phone repair South Mumbai',
  },
  faqs: [
    {
      q: 'Do you repair iPhones at offices in Lower Parel?',
      a: 'Yes! Lower Parel corporate offices are our most popular service location. We come to your office lobby, reception, or meeting room. Most repairs take 30-60 minutes.',
    },
    {
      q: 'How does your service compare to Apple authorized centers?',
      a: 'We use the same OEM-quality parts, provide 6-month warranty, and ensure zero Unknown Part warnings — but at 40-50% lower cost and without any waiting time. We come to you.',
    },
    {
      q: 'Can you come to my apartment in Worli Sea Face towers?',
      a: 'Absolutely. We regularly service residents in Worli Sea Face high-rises including Omkar 1973, Raheja Atlantis, Lodha Park, and others. We\'ll come up to your flat.',
    },
    {
      q: 'What\'s the cost of iPhone screen replacement in Lower Parel?',
      a: 'iPhone screen replacement varies by model — starting from ₹3,499 for older models to ₹8,999 for the latest Pro Max series. All repairs come with 90-day warranty.',
    },
  ],
};

const WorliPage: React.FC = () => <AreaLandingPage area={worli} />;
export default WorliPage;
